import posthog from 'posthog-js';

const isProduction = window.location.href.includes('dashboard.mymember.site')

export const identifyUser = (uuid, options) => {
   if(!isProduction) return;
   posthog.identify(uuid, options);
};
export const startSessionRecording = () => {
   if(!isProduction) return;
   posthog.startSessionRecording()
};
export const stopSessionRecording = () => {
   if(!isProduction) return;
   posthog.stopSessionRecording()
};
